import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { MenuItem, Button } from '@material-ui/core';
import Spinner from '../../util/Spinner';
import { useRootStore } from '../../../stores/BridgeProvider';
import SimpleSelect from '../../util/SimpleSelect';
import {
  FlexDiv,
  StandardBox,
  NewOrg,
  CancelOrg,
  OrgOption,
} from '../../styles/styles';
import { safeEval } from '../../util/UtilFunctions';

const LinkOrg = () => {
  const history = useHistory();
  const { authStore } = useRootStore();
  const [isLoading, setLoading] = useState(true);
  const [orgList, setOrgList] = useState([]);
  const [xeroOrgList, setXeroOrgList] = useState([]);
  const [selectedXeroOrg, setSelectedXeroOrg] = useState(null);
  const [selectedDlmOrg, setSelectedDlmOrg] = useState(null);

  useEffect(() => {
    const fetchDlmOrgs = async () => {
      const { data } = await authStore.request.get(
        `${process.env.REACT_APP_API}/api/unlinked-organizations`,
      );
      setOrgList(data);
    };

    const fetchXeroOrgs = async () => {
      const { data } = await authStore.request.get(
        `${process.env.REACT_APP_API}/api/unlinked-xero-organizations`,
      );
      setXeroOrgList(data);
    };

    const initialActions = async () => {
      const requests = [fetchDlmOrgs(), fetchXeroOrgs()];
      await Promise.all(requests);
      setLoading(false);
    };
    initialActions();
  }, []);

  useEffect(() => {
    if (xeroOrgList && xeroOrgList.length === 1) {
      setSelectedXeroOrg(xeroOrgList[0].OrganisationId);
    }
  }, [xeroOrgList]);

  const xeroOrgSelectFinder = () =>
    safeEval(
      () =>
        xeroOrgList.find(
          ({ OrganisationId }) => OrganisationId === selectedXeroOrg,
        ) || {},
      {},
    );

  const linkOrg = async () => {
    const dlmOrgId = selectedDlmOrg === 'newOrg' ? null : selectedDlmOrg;
    try {
      const syncDateTime = new Date();
      await authStore.request.post(
        `${process.env.REACT_APP_API}/api/link-xero`,
        {
          organisationId: selectedXeroOrg,
          dlmOrgId,
          isDemoCompany: !!xeroOrgSelectFinder().IsDemoCompany,
        },
      );

      history.push({
        pathname: '/sync-in-progress',
        state: { syncDateTime },
      });
    } catch (e) {
      console.error(e);
    }
  };

  const cancelLink = async () => {
    history.push('/select-organization');
  };

  if (isLoading) return <Spinner />;
  if (!xeroOrgList || xeroOrgList.length === 0) {
    return (
      <FlexDiv>
        <StandardBox style={{ justifyContent: 'center' }}>
          <h3 style={{ margin: '0px' }}>
            Unable to get Xero organization or your organization has already
            been linked.
          </h3>
          <CancelOrg onClick={() => cancelLink()}>Back</CancelOrg>
        </StandardBox>
      </FlexDiv>
    );
  }

  return (
    <FlexDiv>
      <StandardBox>
        <h2>Link an Organization</h2>
        <SimpleSelect
          label="Xero Org to Link"
          handleChange={val => setSelectedXeroOrg(val.target.value)}
          value={xeroOrgSelectFinder().OrganisationId}
          name="selectedXeroOrg"
          containerStyle={{ width: '100%' }}
        >
          {xeroOrgList.map(({ Name, OrganisationId }) => (
            <MenuItem key={OrganisationId} value={OrganisationId}>
              {Name}
            </MenuItem>
          ))}
        </SimpleSelect>
        <h4 style={{ marginBottom: '0px' }}>
          Deal Map Organizations available for linking
        </h4>
        <SimpleSelect
          label="Deal Map Org to Link"
          handleChange={val => setSelectedDlmOrg(val.target.value)}
          value={safeEval(
            () => orgList.find(({ OrgId }) => OrgId === selectedDlmOrg),
            null,
          )}
          name="selectedDlmOrg"
          containerStyle={{ width: '100%' }}
        >
          {orgList.map(({ Name, OrgId }) => (
            <MenuItem key={OrgId} value={OrgId}>
              {Name}
            </MenuItem>
          ))}
          <MenuItem value="newOrg">Create new organization from Xero</MenuItem>
        </SimpleSelect>
        <Button
          onClick={() => linkOrg()}
          disabled={!selectedDlmOrg || !selectedXeroOrg}
          color="primary"
          variant="contained"
        >
          Submit
        </Button>
        <CancelOrg onClick={() => cancelLink()}>Cancel</CancelOrg>
      </StandardBox>
    </FlexDiv>
  );
};

export default LinkOrg;
